import styled from "styled-components";
import { Form } from "react-bootstrap";
import { FaTrash } from "react-icons/fa";

export const Descricao = styled.p`
  font-size: 0.9rem;
  color: #4b5563;
  margin-bottom: 16px;
`;

export const CaixaCampos = styled.div`
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
`;

export const Campo = styled.div`
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const LinhaCampos = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-end;
`;

export const CampoFlex = styled(Form.Group)`
  flex: 1;
`;

export const LabelDica = styled.span`
  color: #888;
  font-weight: 400;
  font-size: 0.8rem;
`;

export const IconeRemoverPagamento = styled(FaTrash)`
  cursor: pointer;
  margin-bottom: 10px;
`;

export const ExemploBox = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  background-color: #e8f1fc;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 0.8rem;
  color: #1351b4;
  margin-bottom: 16px;

  svg {
    margin-top: 2px;
    flex-shrink: 0;
    color: #1351b4;
  }
`;

export const FooterBotoes = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

export const ErrosResumo = styled.div`
  margin-top: 16px;
  margin-bottom: 8px;
  font-size: 0.85rem;
  font-weight: 600;
  color: #ee5353;
`;

export const ListaArquivos = styled.div`
  display: grid;
  gap: 12px;
  max-height: 20vh;
  overflow-y: auto;
  padding-right: 4px;
`;

export const ArquivoLinha = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid #f0f0f0;
  padding: 12px 4px;

  svg {
    cursor: pointer;
    color: #9ca3af;
    flex-shrink: 0;
  }
`;

export const SiglasBusca = styled.input`
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 0.85rem;
  margin: 12px 0;
`;

export const ArquivoNome = styled.div`
  font-size: 0.85rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ErroArquivo = styled.div`
  color: #ee5353;
  font-size: 0.75rem;
  margin-top: 2px;
`;

export const SiglasRef = styled.div`
  margin-top: 16px;
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 12px 16px;
`;

export const SiglasToggle = styled.button`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: transparent;
  border: none;
  padding: 4px 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: #1f2937;
  cursor: pointer;
`;

export const SiglasTabelaWrapper = styled.div`
  max-height: 220px;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 6px;

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.8rem;

    th,
    td {
      border-bottom: 1px solid #e5e7eb;
      padding: 8px 10px;
      text-align: left;
    }

    thead th {
      position: sticky;
      top: 0;
      background-color: #f1f3f5;
      z-index: 1;
    }

    tbody tr:last-child td {
      border-bottom: none;
    }
  }
`;
